import React, { useEffect } from 'react';
import { Container } from 'components/apollo';
import { Row, Column } from 'components/grid';
import classNames from 'classnames';
import Loader from 'components/loader';

const UnregisterRemain = ({ match, remainPartner, success, error, loading }) => {
  const { personId } = match.params;

  useEffect(() => {
    if (personId) {
      remainPartner(personId);
    }
  }, [personId, remainPartner]);

  const contentCols = {
    mobile: { size: 12, offset: 0 },
    tablet: { size: 12, offset: 0 },
    desktop: { size: 8, offset: 2 },
    largeDesktop: { size: 8, offset: 2 },
  };

  const classes = classNames('unregister-remain');
  const contentClasses = classNames('unregister-remain-content');

  if (loading) {
    return <Loader width={100} height={100} />;
  }

  if (error) {
    return (
      <div className={classes}>
        <Container className={'unregister-mobile-container'}>
          <Row>
            <Column
              mobile={contentCols.mobile}
              tablet={contentCols.tablet}
              desktop={contentCols.desktop}
              largeDesktop={contentCols.largeDesktop}
            >
              <div className={contentClasses}>
                <h2>Happy to see you staying in the AFRY Partner Network</h2>
                <p>Something went wrong. Please try again later or contact{' '}
                  <a href="mailto:PartnerBusinessSupport@afry.com">PartnerBusinessSupport@afry.com</a>.
                </p>
              </div>
            </Column>
          </Row>
        </Container>
      </div>
    );
  }

  return (
    <div className={classes}>
      <Container className={'unregister-mobile-container'}>
        <Row>
          <Column
            mobile={contentCols.mobile}
            tablet={contentCols.tablet}
            desktop={contentCols.desktop}
            largeDesktop={contentCols.largeDesktop}
          >
            <div className={contentClasses}>
              <h2>Happy to see you staying in the AFRY Partner Network</h2>
              <p>
                Thank you for choosing to stay in the AFRY Partner Network! We're thrilled
                to continue collaborating with you and supporting your journey with us.
              </p>
              <p>
                As we upgrade our system for managing profiles, we encourage you to log in
                and update your profile. Keeping your information up to date will enhance
                your chances of being matched with future assignments. Click the link below
                to get started:
              </p>
              <p>
                <a href="https://portal.afry.com">Click here to log in and update your profile</a>
              </p>
              <p>
                If you have any questions or need assistance, our team is here to help.
                Don't hesitate to reach out to us at{' '}
                <a href="mailto:PartnerBusinessSupport@afry.com">PartnerBusinessSupport@afry.com</a>.
              </p>
              <p>We look forward to many more successful collaborations ahead!</p>
              <p>Best regards,
                <br />
                AFRY Partner Network
              </p>
            </div>
          </Column>
        </Row>
      </Container>
    </div>
  );
};

export default UnregisterRemain;